import { AnnounceArtist as GQLItem } from '../generated/graphql';
import { take } from '../util';

export type AnnounceArtist = {
  id: number;
  name: string;
  applemusic?: string;
  bandcamp?: string;
  facebook?: string;
  instagram?: string;
  lastfm?: string;
  spotify?: string;
  songkick?: string;
  twitter?: string;
  website?: string;
  wikipedia?: string;
  youtube?: string;
};

export const fromGql = (item: GQLItem): AnnounceArtist =>
  take(item, 'id', 'name', 'instagram', 'facebook', 'twitter', 'website', 'spotify', 'youtube', 'lastfm', 'applemusic', 'wikipedia', 'songkick', 'bandcamp');
